import React from 'react';
import PropTypes from 'prop-types';
import SMCalendarBaloonBaseView from './SMCalendarBaloonBaseView';
import SMRoomExceptionHelper from 'components/helpers/SMRoomExceptionHelper';
import SMRoomExceptionResource from 'resources/SMRoomExceptionResource';
import SMConst from 'lib/SMConst';

class SMORoomExceptionCalendarBaloon extends SMCalendarBaloonBaseView {
  
  handleClickSaveButton(e) {
    e.preventDefault();
    e.persist();
    let form = this.refs.form,
        formData = new FormData(form),
        responseHandler = (data, error, xhr)=>{
          if (xhr.status == 200 || xhr.status == 201) {
            this.props.delegate.formDidUpdate(e);
            this.unmount();
          } else if (xhr.status == 400) {
            this.setState({errors: xhr.responseJSON.errors});
          } else {
          }
        };
        
    if (this.props.item) {
      SMRoomExceptionResource.updateException(this.props.item.id, formData, {}, responseHandler);
    } else {
      SMRoomExceptionResource.postException(formData, {}, responseHandler);
    }
  }
  
  handleClickDeleteButton(e) {
    e.preventDefault();
    e.persist();
    let form = this.refs.form,
        responseHandler = (data, error, xhr)=>{
          if (xhr.status == 204) {
            this.props.delegate.formDidUpdate(e);
            this.unmount();
          } else {
          }
        };
        
    SMRoomExceptionResource.deleteException(this.props.item.id, {room_id: this.props.room.id}, responseHandler);
  }
  
  priceName() {
    if (this.props.plan.rent_type == SMConst.RentType.DayTime) {
      if (this.props.plan.has_session_price) {
        return 'session_price';
      } else {
        if (this.props.selectedCalendar == SMConst.CalendarType.DailyPrice) {
          return 'daily_price';
        } else {
          return 'hourly_price';
        }
      }
    } else if (this.props.plan.rent_type == SMConst.RentType.Stay) {
      return 'stay_price';
    }
  }
  
  renderHourSetting() {
    if (this.props.selectedCalendar == SMConst.CalendarType.HourlyPrice) {
      return(
        <div className="special-price__box">
          <input type="radio" value={true} id="form-radio02__01" name="is_all_day" defaultChecked={this.props.item ? !!this.props.item.is_all_day : true} />
          <label htmlFor="form-radio02__01" className="form-radio__s">終日</label>
          <input type="radio" value={false} id="form-radio02__02" name="is_all_day" defaultChecked={this.props.item ? !this.props.item.is_all_day : false} />
          <label htmlFor="form-radio02__02" className="form-radio__s">特定の時間</label>
          <span className="message-disabled">
            <input type="text" className="w40" name="start_hour" placeholder="9" defaultValue={this.props.item ? this.props.item.start_hour : null} /> :00
              <span className="ml5 mr5">〜</span>
            <input type="text" className="w40" name="end_hour" placeholder="20"  defaultValue={this.props.item ? this.props.item.end_hour : null} /> :00
          </span>
        </div>
      );
    } else {
      return <input type='hidden' value={true} name='is_all_day' />;
    }
  }
  
  renderStatusToggle() {
    if (this.props.item) {
      return(
        <div className="special-price__box">
          <input type="hidden" value={1} name="status" />
          <input type="checkbox" value={0} id="form-checkbox02__01" name="status" defaultChecked={!this.props.item.status} />
          <label htmlFor="form-checkbox02__01" className="form-checkbox__s">この価格設定を一時的に無効にする</label>
        </div>
      );
    } else {
      return null;
    }
  }
  
  priceUnitText() {
    if (this.props.plan.rent_type == SMConst.RentType.DayTime) {
      if (this.props.plan.has_session_price) {
        return this.props.plan.session_price_unit_text;
      } else {
        if (this.props.selectedCalendar == SMConst.CalendarType.DailyPrice) {
          return this.props.plan.daily_price_unit_text;
        } else {
          return this.props.plan.hourly_price_unit_text;
        }
      }
    } else if (this.props.plan.rent_type == SMConst.RentType.Stay) {
      return '泊';
    }
  }
  
  startDay() {
    let startDay;
    if (this.props.selectedDate) {
      startDay = I18n.l('date.ymd_simple', this.props.selectedDate);
    }
    if (this.props.item) {
      startDay = I18n.l('date.ymd_simple', this.props.item.started_at);
    }
    
    return startDay;
  }
  
  endDay() {
    let endDay;
    if (this.props.selectedDate) {
      endDay = I18n.l('date.ymd_simple', this.props.selectedDate);
    }
    if (this.props.item) {
      let endedAt = new Date(this.props.item.ended_at);
      endDay = I18n.l('date.ymd_simple', endedAt.setDate(endedAt.getDate()));
    }
    
    return endDay;
  }
  
  startWeekDay() {
    let results = [false,false,false,false,false,false,false];
    if (this.props.item) {
      let startWeekDay = this.props.item.start_weekday.split(',');
      for (let i=0; i < I18n.t('date.abbr_day_names').length; i++) {
        results[i] = false;
        for (let j=0; j < startWeekDay.length; j++) {
          if (parseInt(startWeekDay[j]) == i) {
            results[i] = true;
            break;
          }
        }
      }
    }
    
    return results;
  }
  
  render() {
    return(
      <div className="baloon special-price__baloon js-calendar-baloon">
        <div className="baloon-inner special-price__baloon-inner">
          <h3 className="dashboard-title2 mb20">価格を変更する</h3>

          <form ref="form">
            {this.props.plan == this.props.room ? <input key={'room-'+this.props.room.id} type='hidden' name='room_id' defaultValue={this.props.room.id} />
                                                : <input key={'plan-'+this.props.plan.id} type='hidden' name='plan_id' defaultValue={this.props.plan.id} /> }
            {this.props.item ? <input key={'exception-'+this.props.item.id} type='hidden' name='id' defaultValue={this.props.item.id} /> : null}
            <div className="special-price__box">
              <input type="text" ref="inputStart" className="js-datepicker w110" name="start_day" defaultValue={this.startDay()} />
              <span className="ml5 mr5">〜</span>
              <input type="text" ref="inputEnd" className="js-datepicker w110" name="end_day" defaultValue={this.endDay()} />
            </div>

            <div className="special-price__box">
              <input type="radio" value="1" id="form-radio01__01" name="frequency" defaultChecked={this.props.item ? this.props.item.frequency == 1 : true} />
              <label htmlFor="form-radio01__01" className="form-radio__s">毎日</label>
              <input type="radio" value="2" id="form-radio01__02" name="frequency" defaultChecked={this.props.item ? this.props.item.frequency == 2 : false} />
              <label htmlFor="form-radio01__02" className="form-radio__s">特定の日</label>
            
              <input type='hidden' name='start_weekday[]' defaultValue='' />
              <input type="checkbox" value="0" id="form-checkbox01__01" name="start_weekday[]" defaultChecked={this.startWeekDay()[0]} />
              <label htmlFor="form-checkbox01__01" className="form-checkbox__s w35">日</label>
              <input type="checkbox" value="1" id="form-checkbox01__02" name="start_weekday[]" defaultChecked={this.startWeekDay()[1]} />
              <label htmlFor="form-checkbox01__02" className="form-checkbox__s w35">月</label>
              <input type="checkbox" value="2" id="form-checkbox01__03" name="start_weekday[]" defaultChecked={this.startWeekDay()[2]} />
              <label htmlFor="form-checkbox01__03" className="form-checkbox__s w35">火</label>
              <input type="checkbox" value="3" id="form-checkbox01__04" name="start_weekday[]" defaultChecked={this.startWeekDay()[3]} />
              <label htmlFor="form-checkbox01__04" className="form-checkbox__s w35">水</label>
              <input type="checkbox" value="4" id="form-checkbox01__05" name="start_weekday[]" defaultChecked={this.startWeekDay()[4]} />
              <label htmlFor="form-checkbox01__05" className="form-checkbox__s w35">木</label>
              <input type="checkbox" value="5" id="form-checkbox01__06" name="start_weekday[]" defaultChecked={this.startWeekDay()[5]} />
              <label htmlFor="form-checkbox01__06" className="form-checkbox__s w35">金</label>
              <input type="checkbox" value="6" id="form-checkbox01__07" name="start_weekday[]" defaultChecked={this.startWeekDay()[6]} />
              <label htmlFor="form-checkbox01__07" className="form-checkbox__s w35">土</label>
              <input type='hidden' name='is_holiday' defaultValue='0' />
              <input type="checkbox" value="1" id="form-checkbox01__08" name="is_holiday" defaultChecked={this.props.item ? this.props.item.is_holiday : false} />
              <label htmlFor="form-checkbox01__08" className="form-checkbox__s">祝日</label>
            </div>

            {this.renderHourSetting()}

            <div className="special-price__box">
              ¥ <input type="text" 
                  className="w110" 
                  name={this.priceName()}
                  defaultValue={SMRoomExceptionHelper.price(this.props.item, this.props.plan, this.props.selectedCalendar)} /> /{this.priceUnitText()}
            </div>

            {this.renderStatusToggle()}

            <a href="#" className="button button-blue pt10 pb10 w110" onClick={this.handleClickSaveButton.bind(this)}>保存する</a>
            {this.props.item ? <a href="#" className="fr link-hover-border mt10" onClick={this.handleClickDeleteButton.bind(this)}>削除する</a> : null}
          </form>

        </div>
      </div>
    );
  }
}

SMORoomExceptionCalendarBaloon.propTypes = {
  room: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  selectedCalendar: PropTypes.number.isRequired,
  selectedDate: PropTypes.instanceOf(Date),
};

export default SMORoomExceptionCalendarBaloon;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMORoomExceptionCalendarBaloon.jsx